export default __webpack_public_path__ + "static/media/izzy.f2d998b2.jpg";